define(
	'app/ui/cookie/cookie',[
		'jquery',
		'app/ui/permissions/permissions'
	],

	function ($, Permissions) {

		var Cookie = {
			init: function () {
				Permissions.get({
					type: 'cookie'
				});
			}
		};

		return {
			init: Cookie.init
		};

	}
);
